import {
  ACCOUNT_USER_DETAIL_URL_PATH,
  BALANCE_EXECUTION_URL_PATH,
  BRAND_ALL_LIST_URL_PATH,
  BRAND_DETAIL_URL_PATH,
  COUPON_DETAIL_URL_PATH,
  CS_REVIEW_DETAIL_URL_PATH,
  EVENT_EDIT_URL_PATH,
  ORDER_DETAIL_URL_PATH,
  PRODUCT_ALL_LIST_URL_PATH,
  PRODUCT_DETAIL_URL_PATH,
  PROMOTION_SCHEDULE_DETAIL_URL_PATH,
  SUB_PAGE_MANAGEMENT_URL_PATH,
  TAG_EDIT_URL_PATH,
  WIDGET_EDIT_URL_PATH,
} from './urlConstants';

/**
 *  앱 링크 타입
 */
export const APP_LINK_TYPE = {
  /**
   *  홈(위젯) 상세 페이지
   */
  HOME_WIDGET_DETAIL: 0,
  /**
   *  브랜드 상세 페이지
   */
  BRAND_DETAIL: 1,
  /**
   *  기획전 상세 페이지
   */
  EVENT_DETAIL: 2,
  /**
   *  상품 목록 페이지
   */
  PRODUCT_LIST: 3,
  /**
   *  브랜드 목록 페이지
   */
  BRAND_LIST: 4,
  /**
   *  찜 상품 목록 페이지
   */
  LIKE_PRODUCT_LIST: 5,
  /**
   *  찜 브랜드 목록 페이지
   */
  LIKE_BRAND_LIST: 6,
  /**
   *  장바구니 페이지
   */
  CART: 7,
  /**
   *  포인트 페이지
   */
  POINT: 8,
  /**
   *  쿠폰 페이지
   */
  COUPON: 9,
  /**
   *  레퍼럴 페이지
   */
  REFERRAL: 10,
  /**
   *  주문 배송 조회 목록
   */
  ORDER_DELIVERY_SEARCH_LIST: 11,
  /**
   *  상품 후기 쓰기 탭
   */
  REVIEW_WRITE_TAB: 12,
  /**
   *  상품 후기 작성한 내역 탭
   */
  REVIEW_HISTORY_TAB: 13,
  /**
   *  회원정보 수정 페이지
   */
  MEMBER_INFO_EDIT: 14,
  /**
   *  알림 설정 페이지
   */
  SET_ALARM: 15,
  /**
   *  상품 상세 페이지
   */
  PRODUCT_DETAIL: 16,
  /**
   *  후기 상세
   */
  REVIEW_DETAIL: 17,
  /**
   *  태그 탭
   */
  TAG_TAB: 18,
  /**
   *  태그 상세 - 갤러리
   */
  TAG_DETAIL_GALLERY: 19,
  /**
   *  태그 상세 - 피드
   */
  TAG_DETAIL_FEED: 20,
  /**
   *  웹페이지
   */
  WEB_PAGE: 1000,
  /**
   *  카테고리 페이지
   */
  CATEGORY_PAGE: 1001,
  /**
   * 홈 페이지(메인, 서브)
   */
  HOME_PAGE: 2000,
};

/**
 *  앱 링크 타입에 따른 어드민 URL경로
 */
export const APP_LINK_TYPE_URL = {
  /**
   *  홈(위젯) 상세 페이지
   */
  [APP_LINK_TYPE.HOME_WIDGET_DETAIL]: WIDGET_EDIT_URL_PATH,
  /**
   *  브랜드 상세 페이지
   */
  [APP_LINK_TYPE.BRAND_DETAIL]: BRAND_DETAIL_URL_PATH,
  /**
   *  기획전 상세 페이지
   */
  [APP_LINK_TYPE.EVENT_DETAIL]: EVENT_EDIT_URL_PATH,
  /**
   *  상품 목록 페이지
   */
  [APP_LINK_TYPE.PRODUCT_LIST]: PRODUCT_ALL_LIST_URL_PATH,
  /**
   *  브랜드 목록 페이지
   */
  [APP_LINK_TYPE.BRAND_LIST]: BRAND_ALL_LIST_URL_PATH,
  /**
   *  쿠폰 페이지
   */
  [APP_LINK_TYPE.COUPON]: COUPON_DETAIL_URL_PATH,
  /**
   *  상품 상세 페이지
   */
  [APP_LINK_TYPE.PRODUCT_DETAIL]: PRODUCT_DETAIL_URL_PATH,
  /**
   *  후기 상세
   */
  [APP_LINK_TYPE.REVIEW_DETAIL]: CS_REVIEW_DETAIL_URL_PATH,
  /**
   * 홈 페이지(메인, 서브)
   */
  [APP_LINK_TYPE.HOME_PAGE]: SUB_PAGE_MANAGEMENT_URL_PATH,
};

/**
 *  앱 링크 타입 텍스트
 */
export const APP_LINK_TYPE_TEXT = {
  [APP_LINK_TYPE.HOME_WIDGET_DETAIL]: `홈(위젯) 상세 페이지(${APP_LINK_TYPE.HOME_WIDGET_DETAIL})`,
  [APP_LINK_TYPE.BRAND_DETAIL]: `브랜드 상세 페이지(${APP_LINK_TYPE.BRAND_DETAIL})`,
  [APP_LINK_TYPE.EVENT_DETAIL]: `기획전 상세 페이지(${APP_LINK_TYPE.EVENT_DETAIL})`,
  [APP_LINK_TYPE.PRODUCT_LIST]: `상품 목록 페이지(${APP_LINK_TYPE.PRODUCT_LIST})`,
  [APP_LINK_TYPE.BRAND_LIST]: `브랜드 목록 페이지(${APP_LINK_TYPE.BRAND_LIST})`,
  [APP_LINK_TYPE.LIKE_PRODUCT_LIST]: `찜 상품 목록 페이지(${APP_LINK_TYPE.LIKE_PRODUCT_LIST})`,
  [APP_LINK_TYPE.LIKE_BRAND_LIST]: `찜 브랜드 목록 페이지(${APP_LINK_TYPE.LIKE_BRAND_LIST})`,
  [APP_LINK_TYPE.CART]: `장바구니 페이지(${APP_LINK_TYPE.CART})`,
  [APP_LINK_TYPE.POINT]: `포인트 페이지(${APP_LINK_TYPE.POINT})`,
  [APP_LINK_TYPE.COUPON]: `쿠폰 페이지(${APP_LINK_TYPE.COUPON})`,
  [APP_LINK_TYPE.REFERRAL]: `레퍼럴 페이지(${APP_LINK_TYPE.REFERRAL})`,
  [APP_LINK_TYPE.ORDER_DELIVERY_SEARCH_LIST]: `주문 배송 조회 목록(${APP_LINK_TYPE.ORDER_DELIVERY_SEARCH_LIST})`,
  [APP_LINK_TYPE.REVIEW_WRITE_TAB]: `상품 후기 쓰기 탭(${APP_LINK_TYPE.REVIEW_WRITE_TAB})`,
  [APP_LINK_TYPE.REVIEW_HISTORY_TAB]: `상품 후기 작성한 내역 탭(${APP_LINK_TYPE.REVIEW_HISTORY_TAB})`,
  [APP_LINK_TYPE.MEMBER_INFO_EDIT]: `회원정보 수정 페이지(${APP_LINK_TYPE.MEMBER_INFO_EDIT})`,
  [APP_LINK_TYPE.SET_ALARM]: `알림 설정 페이지(${APP_LINK_TYPE.SET_ALARM})`,
  [APP_LINK_TYPE.PRODUCT_DETAIL]: `상품 상세 페이지(${APP_LINK_TYPE.PRODUCT_DETAIL})`,
  [APP_LINK_TYPE.REVIEW_DETAIL]: `후기 상세(${APP_LINK_TYPE.REVIEW_DETAIL})`,
  [APP_LINK_TYPE.TAG_TAB]: `태그 탭(${APP_LINK_TYPE.TAG_TAB})`,
  [APP_LINK_TYPE.TAG_DETAIL_GALLERY]: `태그 상세 - 갤러리(${APP_LINK_TYPE.TAG_DETAIL_GALLERY})`,
  [APP_LINK_TYPE.TAG_DETAIL_FEED]: `태그 상세 - 피드(${APP_LINK_TYPE.TAG_DETAIL_FEED})`,
  [APP_LINK_TYPE.WEB_PAGE]: `웹페이지(${APP_LINK_TYPE.WEB_PAGE})`,
  [APP_LINK_TYPE.CATEGORY_PAGE]: `카테고리 페이지(${APP_LINK_TYPE.CATEGORY_PAGE})`,
  [APP_LINK_TYPE.HOME_PAGE]: `서브 페이지(${APP_LINK_TYPE.HOME_PAGE})`,
};

/**
 *  관리자 메모 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_ADMIN_MEMO_TEXT = 1000;

/**
 *  글로벌 검색 타입
 */
export const GLOBAL_SEARCH_TYPE = {
  /**
   *  상품 상세
   */
  PRODUCT_DETAIL_URL_TYPE: 0,
  /**
   *  브랜드 상세
   */
  BRAND_DETAIL_URL_TYPE: 1,
  /**
   *  상품 주문 상세
   */
  ORDER_DETAIL_URL_TYPE: 2,
  /**
   *  상품 후기 상세
   */
  REVIEW_DETAIL_URL_TYPE: 3,
  /**
   *  유저 상세
   */
  USER_DETAIL_URL_TYPE: 4,
  /**
   *  정산 상세
   */
  BALANCE_DETAIL_URL_TYPE: 5,
  /**
   *  태그 상세
   */
  TAG_DETAIL_URL_TYPE: 6,
  /**
   *  기획전 상세
   */
  EVENT_DETAIL_URL_TYPE: 7,
  /**
   *  위젯 상세
   */
  WIDGET_DETAIL_URL_TYPE: 8,
  /**
   *  쿠폰 상세
   */
  COUPON_DETAIL_URL_TYPE: 9,
  /**
   *  프로모션 상세
   *
   *  ⚠️ 바로 위 `기획전번호` 와 나란히 선다. 둘은 **계획(프로모션) vs 산출물(기획전)** 로
   *  다른 것이라 운영팀에 구분을 안내해야 한다.
   */
  PROMOTION_SCHEDULE_DETAIL_URL_TYPE: 10,
};

/**
 *  글로벌 검색 타입 링크
 */
export const GLOBAL_SEARCH_TYPE_URL = {
  [GLOBAL_SEARCH_TYPE.PRODUCT_DETAIL_URL_TYPE]: PRODUCT_DETAIL_URL_PATH,
  [GLOBAL_SEARCH_TYPE.BRAND_DETAIL_URL_TYPE]: BRAND_DETAIL_URL_PATH,
  [GLOBAL_SEARCH_TYPE.ORDER_DETAIL_URL_TYPE]: ORDER_DETAIL_URL_PATH,
  [GLOBAL_SEARCH_TYPE.REVIEW_DETAIL_URL_TYPE]: CS_REVIEW_DETAIL_URL_PATH,
  [GLOBAL_SEARCH_TYPE.USER_DETAIL_URL_TYPE]: ACCOUNT_USER_DETAIL_URL_PATH,
  [GLOBAL_SEARCH_TYPE.BALANCE_DETAIL_URL_TYPE]: BALANCE_EXECUTION_URL_PATH,
  [GLOBAL_SEARCH_TYPE.TAG_DETAIL_URL_TYPE]: TAG_EDIT_URL_PATH,
  [GLOBAL_SEARCH_TYPE.EVENT_DETAIL_URL_TYPE]: EVENT_EDIT_URL_PATH,
  [GLOBAL_SEARCH_TYPE.WIDGET_DETAIL_URL_TYPE]: WIDGET_EDIT_URL_PATH,
  [GLOBAL_SEARCH_TYPE.COUPON_DETAIL_URL_TYPE]: COUPON_DETAIL_URL_PATH,
  [GLOBAL_SEARCH_TYPE.PROMOTION_SCHEDULE_DETAIL_URL_TYPE]: PROMOTION_SCHEDULE_DETAIL_URL_PATH,
};

/**
 *  글로벌 검색 타입 리스트
 */
export const GLOBAL_SEARCH_TYPE_SELECT_LIST = [
  {
    id: GLOBAL_SEARCH_TYPE.PRODUCT_DETAIL_URL_TYPE,
    name: '상품번호',
  },
  {
    id: GLOBAL_SEARCH_TYPE.BRAND_DETAIL_URL_TYPE,
    name: '브랜드번호',
  },
  {
    id: GLOBAL_SEARCH_TYPE.ORDER_DETAIL_URL_TYPE,
    name: '상품 주문번호',
  },
  {
    id: GLOBAL_SEARCH_TYPE.REVIEW_DETAIL_URL_TYPE,
    name: '상품 후기번호',
  },
  {
    id: GLOBAL_SEARCH_TYPE.USER_DETAIL_URL_TYPE,
    name: '유저번호',
  },
  {
    id: GLOBAL_SEARCH_TYPE.BALANCE_DETAIL_URL_TYPE,
    name: '정산번호',
  },
  {
    id: GLOBAL_SEARCH_TYPE.TAG_DETAIL_URL_TYPE,
    name: '태그번호',
  },
  {
    id: GLOBAL_SEARCH_TYPE.EVENT_DETAIL_URL_TYPE,
    name: '기획전번호',
  },
  {
    id: GLOBAL_SEARCH_TYPE.PROMOTION_SCHEDULE_DETAIL_URL_TYPE,
    name: '프로모션번호',
  },
  {
    id: GLOBAL_SEARCH_TYPE.WIDGET_DETAIL_URL_TYPE,
    name: '위젯번호',
  },
  {
    id: GLOBAL_SEARCH_TYPE.COUPON_DETAIL_URL_TYPE,
    name: '쿠폰번호',
  },
];

/**
 *  % 최소 값
 */
export const MINIMUM_PERCENT = 0;

/**
 *  % 최대 값
 */
export const MAXIMUM_PERCENT = 100;

/**
 *  % 단위
 */
export const PERCENT_UNIT = 0.1;

/**
 *  오늘 출발 여부
 */
export const TODAY_DELIVERY_TYPE = {
  GENERAL: 0,
  TODAY: 1,
};

/**
 *  오늘 출발 여부 텍스트
 */
export const TODAY_DELIVERY_TYPE_TEXT = {
  [TODAY_DELIVERY_TYPE.GENERAL]: '일반',
  [TODAY_DELIVERY_TYPE.TODAY]: '오늘 출발',
};

/**
 *  주문 내역 사이드바 key
 */
export const ORDER_LIST_SIDEBAR_KEY = 'orderList';

/**
 *  주문 관리 사이드바 key
 */
export const ORDER_MANAGEMENT_SIDEBAR_KEY = 'order';

/**
 *  비디오 비율 타입
 */
export const VIDEO_RATIO_TYPE = {
  /**
   *  1:1
   */
  RATIO_1_X_1: 0,
  /**
   *  4:5
   */
  RATIO_4_X_5: 1,
  /**
   *  16:9
   */
  RATIO_16_X_9: 2,
  /**
   *  9:16
   */
  RATIO_9_X_16: 3,
};

/**
 *  비디오 비율 타입 텍스트
 */
export const VIDEO_RATIO_TYPE_TEXT = {
  [VIDEO_RATIO_TYPE.RATIO_1_X_1]: '1:1',
  [VIDEO_RATIO_TYPE.RATIO_4_X_5]: '4:5',
  [VIDEO_RATIO_TYPE.RATIO_16_X_9]: '16:9',
  [VIDEO_RATIO_TYPE.RATIO_9_X_16]: '9:16',
};

/**
 *  비디오 비율 타입 SELECT LIST
 */
export const VIDEO_RATIO_TYPE_SELECT_LIST = [
  {
    id: VIDEO_RATIO_TYPE.RATIO_1_X_1,
    name: VIDEO_RATIO_TYPE_TEXT[VIDEO_RATIO_TYPE.RATIO_1_X_1],
  },
  {
    id: VIDEO_RATIO_TYPE.RATIO_4_X_5,
    name: VIDEO_RATIO_TYPE_TEXT[VIDEO_RATIO_TYPE.RATIO_4_X_5],
  },
  {
    id: VIDEO_RATIO_TYPE.RATIO_16_X_9,
    name: VIDEO_RATIO_TYPE_TEXT[VIDEO_RATIO_TYPE.RATIO_16_X_9],
  },
  {
    id: VIDEO_RATIO_TYPE.RATIO_9_X_16,
    name: VIDEO_RATIO_TYPE_TEXT[VIDEO_RATIO_TYPE.RATIO_9_X_16],
  },
];

/**
 *  비디오 비율 타입 값
 */
export const VIDEO_RATIO_TYPE_VALUE = {
  [VIDEO_RATIO_TYPE.RATIO_1_X_1]: {
    width: 360,
    height: 360,
  },
  [VIDEO_RATIO_TYPE.RATIO_4_X_5]: {
    width: 360,
    height: 450,
  },
  [VIDEO_RATIO_TYPE.RATIO_16_X_9]: {
    width: 640,
    height: 360,
  },
  [VIDEO_RATIO_TYPE.RATIO_9_X_16]: {
    width: 360,
    height: 640,
  },
};

/**
 *  USER WEB URL
 */
// 유저 웹 상품 카테고리 페이지 경로
export const USER_WEB_PRODUCT_CATEGORY_PAGE_PATH = '/product/list';
// 유저 웹 기획전 상세 페이지 경로
export const USER_WEB_EVENT_DETAIL_PAGE_PATH = '/event';

// 이미지 업로드 시 최고 허용 크기 (20MB)
export const IMAGE_MAX_SIZE = 20 * 1024 * 1024;

// 이미지 업로드 시 허용 크기 안내 텍스트 (1MB 미만)
export const IMAGE_SIZE_GUIDE_TEXT = '파일 크기 1MB 미만';

// 이미지 업로드시 허용 파일 형식 안내 텍스트
export const IMAGE_TYPE_GUIDE_TEXT = 'png, jpg, jpeg 형식의 정지 이미지만 등록됩니다.';
